import React from 'react'
import { Component } from 'reflux'

import { actions } from 'actions'
import { runtime } from 'rest/runtime'
import { SupplierStore } from 'stores/SupplierStore'

import { LanguagesWidget } from './languages/MainView'
import { TechnicalWidget } from './technicalcapability/MainView'
import { ContactWidget } from './contact/MainView'
import { DocumentsWidget } from './documents/MainView'
import TimestampWidget from './timestamp/MainView'
import { RatingWidget } from './rating/MainView'
import { Tags } from './tags/MainView'
import { ExperienceWidget } from './experience/MainView'

class Tab extends Component {
  state = {
    supplier: undefined,
  }

  constructor(props) {
    super(props)

    this.mapStoreToState(SupplierStore, this.supplierChanged);
  }

  componentWillMount() {
    const { match: { params: { supplierId } } } = this.props

    actions.getSupplier(supplierId)
    if (runtime.currentUser.isSupplier()) {
      window.document.title = 'Data'
    } else if (runtime.currentUser.isCoordinator()) {
      window.document.title = `Data (${supplierId})`
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.supplierId != prevProps.match.params.supplierId) {
      this.setState({ supplier: undefined })
      actions.getSupplier(this.props.match.params.supplierId)
    }
  }

  supplierChanged = (supplier) => {
    this.setState({ supplier })
  }

  render() {
    const { supplier } = this.state

    if (supplier === undefined) {
      return null
    }

    return (
      <div className="p-4">
        <div className="grid grid-cols-3 gap-4">
          <div className="space-y-4">
            <LanguagesWidget supplier={supplier} />
            <Tags supplier={supplier} />
            <TechnicalWidget supplier={supplier} />
          </div>
          <div className="space-y-4">
            <ContactWidget supplier={supplier} />
            <DocumentsWidget supplier={supplier} />
          </div>
          <div className="space-y-4">
            {runtime.currentUser.isCoordinator() && (
              <RatingWidget supplier={supplier} />
            )}
            {runtime.currentUser.isCoordinator() && (
              <TimestampWidget supplier={supplier} excludeStrategies={['file-download']}/>
            )}
          </div>
        </div>
        <div>
          <ExperienceWidget supplier={supplier} />
        </div>
      </div>
    )
  }
}

export default Tab
